import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import ChatIcon from '@/assets/img/meeting-room/chat-ui.png';
import CharmPowerIcon from '@/assets/img/meeting-room/charm_power.png';
import MembersIcon from '@/assets/img/meeting-room/members-ui.png';
import MicIcon from '@/assets/img/meeting-room/voice-on-ui.png';
import MoreIcon from '@/assets/img/meeting-room/more-ui.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingRoomFooter',
  props: {
    screenFullscreen: { type: Boolean }
  },
  emits: ["action", "leave"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(["room_footer", { screen_fullscreen: _ctx.screenFullscreen }])
  }, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _unref(MicIcon),
          alt: ""
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('请求')), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action')))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _unref(ChatIcon),
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('聊天室')), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('action')))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _unref(MembersIcon),
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('管理成员')), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('action')))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _unref(MoreIcon),
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('更多')), 1)
    ]),
    _createElementVNode("button", {
      class: "pc_leave_action",
      type: "button",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('leave')))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _unref(CharmPowerIcon),
          alt: ""
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("em", null, _toDisplayString(_ctx.$t('离开')), 1)
    ])
  ], 2))
}
}

})